<div class="card cardTyp1 h-100">
    <div class="card-body">
        <div class="d-flex align-items-center gap-lg-3 gap-2 mb-2">
            <i class="stats-icon d-inline-flex fa-solid bg-light p-2 rounded-3 fa-lg align-item-center justify-content-center {{icon}}" [ngClass]="iconClass"></i>
            <h6 class="mt-1">
                {{ title }}
                <span *ngIf="unit" class="small text-secondary fw-normal">{{ unit }}</span>
            </h6>
        </div>
        <div class="row">
            <div class="col">
                <p class="mb-0 fw-semibold fs-1000 d-flex justify-content-between border-bottom mt-1 pb-1">
                    <span class="fw-normal small text-secondary">(YTD)</span>
                    <span>{{ YTDvalue }}</span>
                </p>
                <p class="mb-0 fw-semibold fs-1000 d-flex justify-content-between mt-1">
                    <span class="fw-normal small text-secondary">(MTD)</span>
                    <span>{{ MTDvalue }}</span>
                </p>
            </div>
        </div>
    </div>
</div>
